// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3zGmB","noInteraction":"EventWrapper_noInteraction__zlTRZ","pointerPassthrough":"EventWrapper_pointerPassthrough__1n2Cq"};